import React from 'react';
import PropTypes from 'prop-types';
import { formatDate } from '_helpers/helpers';
import { config } from '../../_helpers';

function formatPhoneNumber(s) {
  var s2 = ('' + s).replace(/\D/g, '');
  var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
  return !m ? null : m[1] + '-' + m[2] + '-' + m[3];
}

const ApplicantLeftColumnSection = ({ applicants, isSupAdmin, checkProperties, checkNull }) => {
  const formatAnswer = (val) =>
    val && val !== 'null' && val !== '' ? val : <span className="av-empty">Did not fill out</span>;

  // --------------------------
  // University Sections
  // --------------------------
  const university1 = [];
  const university2 = [];

  if (checkProperties(applicants.data.university1)) {
    university1.push(
      <p key="university1" id="avTechSchool1" className="av-answer av-answer-clear">
        <span className="av-empty">Did not fill out</span>
      </p>
    );
  } else {
    university1.push(
      <div key="university1" id="avTechSchool1" className="av-answer av-answer-clear">
        <p>{formatAnswer(applicants.data.university1.name)}</p>
        <p>{formatAnswer(applicants.data.university1.years_attended)}</p>
        <p>{formatAnswer(applicants.data.university1.course)}</p>
        <p>{formatAnswer(applicants.data.university1.graduate_status)}</p>
      </div>
    );
  }

  if (checkProperties(applicants.data.university2)) {
    university2.push(
      <p key="university2" id="avTechSchool2" className="av-answer av-answer-clear">
        <span className="av-empty">Did not fill out</span>
      </p>
    );
  } else {
    university2.push(
      <div key="university2" id="avTechSchool2" className="av-answer av-answer-clear">
        <p>{formatAnswer(applicants.data.university2.name)}</p>
        <p>{formatAnswer(applicants.data.university2.years_attended)}</p>
        <p>{formatAnswer(applicants.data.university2.course)}</p>
        <p>{formatAnswer(applicants.data.university2.graduate_status)}</p>
      </div>
    );
  }

  // --------------------------
  // Reference Sections
  // --------------------------
  const reference1 = [];
  const reference2 = [];
  const reference3 = [];

  let reference1_flag = false;
  let reference2_flag = false;
  let reference3_flag = false;

  const ref = (refData, key, title) => {
    if (refData?.last_employee && !checkNull(refData.last_employee)) {
      const items = [];
      items.push(<span key={`${key}-name`}>{refData.last_employee}</span>);

      if (refData.address) items.push(<p key={`${key}-address`}>{refData.address}</p>);
      if (refData.phone) items.push(<p key={`${key}-phone`}>{formatPhoneNumber(refData.phone)}</p>);
      if (refData.position) items.push(<p key={`${key}-position`}>{refData.position}</p>);
      if (refData.supervisor) items.push(<p key={`${key}-supervisor`}>{refData.supervisor}</p>);
      if (refData.start_date || refData.end_date) {
        items.push(
          <p key={`${key}-dates`}>
            {formatDate(refData.start_date)} - {formatDate(refData.end_date)}
          </p>
        );
      }
      if (refData.reason_for_leaving) {
        items.push(<p key={`${key}-reason`}>{refData.reason_for_leaving}</p>);
      }
      if (refData.ok_to_contact) {
        items.push(<p key={`${key}-okcontact`}>OK to Contact: {refData.ok_to_contact}</p>);
      }

      return (
        <div key={key}>
          <p className="av-question">{title}</p>
          <div id={key} className="av-answer av-answer-clear">{items}</div>
        </div>
      );
    } else {
      return (
        <div key={key}>
          <p className="av-question">{title}</p>
          <p id={key} className="av-answer av-answer-clear">
            <span className="av-empty">Did not fill out</span>
          </p>
        </div>
      );
    }
  };

  if (applicants.data.reference1?.last_employee && !checkNull(applicants.data.reference1.last_employee)) {
    reference1_flag = true;
  }
  if (applicants.data.reference2?.last_employee && !checkNull(applicants.data.reference2.last_employee)) {
    reference2_flag = true;
  }
  if (applicants.data.reference3?.last_employee && !checkNull(applicants.data.reference3.last_employee)) {
    reference3_flag = true;
  }

  reference1.push(ref(applicants.data.reference1, 'avReference1', 'Past Experiences / References - #1:'));
  reference2.push(ref(applicants.data.reference2, 'avReference2', 'Past Experiences / References - #2:'));
  reference3.push(ref(applicants.data.reference3, 'avReference3', 'Past Experiences / References - #3:'));

  return (
    <div className="left col-50 applicant-view-left">
      {/* Basic Info */}
      <h4 className="av-title">Basic Information</h4>

      <p className="av-question">How did you hear about {config.companyName}?</p>
      <p className="av-answer av-answer-clear">{formatAnswer(applicants?.data?.source_of_knowledge)}</p>
      <p className="av-answer">{formatAnswer(applicants?.data?.firestorm_employee)}</p>
      <br />

      <div className="left col-50">
        <p className="av-answer">
          {[applicants?.data?.first_name, applicants?.data?.middle_initial, applicants?.data?.last_name]
            .filter(Boolean)
            .join(' ')}
        </p>
        <p className="av-answer">{formatAnswer(applicants?.data?.mailing_address1)}</p>
        <p className="av-answer">{formatAnswer(applicants?.data?.mailing_address2)}</p>
        <p className="av-answer">
          {`${formatAnswer(applicants?.data?.city_id)}, ${formatAnswer(applicants?.data?.state_id)}`}
        </p>
        <p className="av-answer">{formatAnswer(applicants?.data?.zip_id)}</p>
      </div>

      {isSupAdmin && (
        <div className="right col-50">
          <p className="av-answer">Gender: {formatAnswer(applicants.data.gender)}</p>
          <p className="av-answer">Race: {formatAnswer(applicants.data.race)}</p>
          <p className="av-answer">Veteran: {formatAnswer(applicants.data.veteran)}</p>
        </div>
      )}
      <div className="clearfix" />
      <br />

      <p className="av-answer">
        <a className="phone_email_link" href={`mailto:${applicants?.data?.email_address}`}>
          {formatAnswer(applicants?.data?.email_address)}
        </a>
      </p>
      <p className="av-answer">
        <a className="phone_email_link" href={`tel:${applicants?.data?.phone_number}`}>
          {formatPhoneNumber(applicants?.data?.phone_number)}
        </a>
      </p>
      <p className="av-answer">
        <a className="phone_email_link" href={`tel:${applicants?.data?.secondary_phone}`}>
          {formatPhoneNumber(applicants?.data?.secondary_phone)}
        </a>
      </p>

      <br />
      <p className="av-question">Are physically fit to perform duties required to be a wildland firefighter?</p>
      <p className="av-answer av-answer-clear">{formatAnswer(applicants?.data?.question2)}</p>
      <br />
      <p className="av-question">Will you comply to our company drug and smoking policies?</p>
      <p className="av-answer av-answer-clear">{formatAnswer(applicants?.data?.question3)}</p>
      <br />

      {/* Education */}
      <h4 className="av-title">Education and History</h4>
      <p className="av-question">High School:</p>
      <p className="av-answer av-answer-clear">
        {formatAnswer(applicants?.data?.highschool_name)}<br />
        {formatAnswer(applicants?.data?.highschool_duration)}<br />
        {formatAnswer(applicants?.data?.highschool_course)}<br />
        {formatAnswer(applicants?.data?.highschool_gratuate_status)}
      </p>
      <br />
      <p className="av-question">University / Tech School #1:</p>
      {university1}
      <br />
      <p className="av-question">University / Tech School #2:</p>
      {university2}
      <br />
      <p className="av-question">Additional Information:</p>
      <p className="av-answer av-answer-clear">{formatAnswer(applicants?.data?.applicant_info)}</p>
      <br />

      {/* Firestorm History */}
      <p className="av-question">Have you worked for {config.companyName} in the past?</p>
      <p className="av-answer av-answer-clear">{formatAnswer(applicants?.data?.worked_for_firestorm)}</p>
      {applicants?.data?.reason_leave_firestorm && (
        <p className="av-answer av-answer-clear">{applicants.data.reason_leave_firestorm}</p>
      )}

      {/* Past Experience / References */}
      <h4 className="av-title">Past Experiences / Employment Record</h4>
      {!reference1_flag && !reference2_flag && !reference3_flag && (
        <h4 className="av-title">No past work experiences</h4>
      )}
      {reference1}
      {reference2}
      {reference3}
    </div>
  );
};

ApplicantLeftColumnSection.propTypes = {
  applicants: PropTypes.object.isRequired,
  isSupAdmin: PropTypes.bool.isRequired,
};

export default ApplicantLeftColumnSection;
